import React, { useEffect, useState } from 'react';
import { CarruselServices } from './CarruselServices.js';
import { TypeSectionCarrusel } from './TypeSectionCarrusel.js';
import { Publish } from '../shared/Publish.js';
import FiestaSpinner2 from '../shared/FiestaSpinner2.js';
import { Contactanos } from '../shared/Contactanos.js';
import { API_BASE_URL } from '../../config/config.js'; 
import MaintenancePage from '../shared/MaintenancePage.js';


export const Inicio = () => {
  const [services, setServices] = useState([]); // Estado para almacenar los servicios
  const [loading, setLoading] = useState(true); // Estado para manejar la carga
  const [error, setError] = useState(null); // Estado para manejar errores
  const [userLocation, setUserLocation] = useState(null); // Estado para la ubicación
  const [ , setAdFrequency] = useState(2); // Estado para controlar la frecuencia de la publicidad
  
  //console.log('API_BASE_URL:', API_BASE_URL);  // Verifica que esta variable tiene el valor esperado

  // Función para obtener la ubicación del usuario
  const getUserLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          const location = { latitude, longitude };
          
          // Guardamos la ubicación en el localStorage
          localStorage.setItem('userLocation', JSON.stringify(location));
          setUserLocation(location); // Actualizamos el estado
         // console.log('Ubicación obtenida y guardada:', location);
        },
        (error) => {
          console.error('Error al obtener ubicación:', error.message);
         // setError('No se pudo obtener la ubicación.');
        }
      );
    } else {
      console.error('Geolocalización no soportada por tu navegador.');
     // setError('Geolocalización no soportada por tu navegador.');
    }
  };


  // Función asincrónica para obtener los servicios
  const fetchServices = async () => {
    const url = `${API_BASE_URL}/tipoLugares`;
    const timeout = 15000; // Tiempo de espera en milisegundos (por ejemplo, 5 segundos)
  
    try {
      // Crear promesa de timeout
      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Tiempo de espera agotado')), timeout)
      );
  
      // Crear la promesa del fetch
      const fetchPromise = fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(async (response) => {
        if (!response.ok) {
          throw new Error(`Error HTTP: ${response.status}`);
        }
  
        // Obtiene el texto completo de la respuesta (para inspeccionarlo)
        const responseText = await response.text();
  
        console.log('Respuesta completa del servidor:', responseText); // Registra la respuesta completa para diagnóstico
  
        // Verifica si la respuesta es JSON antes de intentar parsearla
        const contentType = response.headers.get('Content-Type');
        if (contentType && contentType.includes('application/json')) {
          try {
            // Intenta convertir la respuesta a JSON
            const data = JSON.parse(responseText);
  
            // Verifica que la respuesta sea un array (ajusta esto según tus datos)
            if (Array.isArray(data)) {
              console.log('Contenido de la respuesta:', data);
              setServices(data); // Establece los datos recibidos en el estado
            } else {
              throw new Error('Datos inválidos recibidos de la API (no es un array)');
            }
          } catch (err) {
            // Si ocurre un error al parsear, la respuesta no es JSON
            console.error('Error al parsear JSON:', err);
            throw new Error('La respuesta no es JSON válida');
          }
        } else {
          throw new Error('La respuesta no es del tipo JSON');
        }
      });
  
      // Usamos Promise.race para que compita entre fetch y el timeout
      await Promise.race([fetchPromise, timeoutPromise]);
  
    } catch (err) {
      // Maneja errores: ya sean HTTP, problemas con el JSON o timeout
      console.error('Error en la solicitud:', err.message);
      setError(err.message); // Establece el mensaje de error
    } finally {
      // Marca la carga como finalizada
      setLoading(false);
    }
  };
  useEffect(() =>{
      
  },[])

  // Usamos useEffect para hacer la llamada una sola vez
  useEffect(() => {
    fetchServices();
    getUserLocation(); // Llamamos a la función para obtener la ubicación al montar el componente
    window.scrollTo(0, 0); // Desplaza la página al inicio
  }, []); // Dependencias vacías para que solo se ejecute una vez

  // Lógica para actualizar la frecuencia de la publicidad
  useEffect(() => {
    // Cambiar la frecuencia después de ciertos índices
    if (services.length > 0) {
      if (services[1]) setAdFrequency(3); // Cambiar a 3 después del segundo servicio
      if (services[4]) setAdFrequency(0); // Cambiar a 0 después del quinto servicio
    }
  }, [services]); // Este useEffect se ejecutará cuando los servicios cambien

  if (loading) {
    return  <div className="centered-spinner">
    <FiestaSpinner2 />
  </div>; // Muestra un mensaje de carga
  }
  

  if (error) {
    // return <div>Error: {error}</div>; // Muestra un mensaje de error si ocurre algún problema
    return <div> <MaintenancePage/></div>;
  }

  return (
    <div className="home">
      <header className="header-home">
        <h1>Bienvenido a Enfiestándonos</h1>
        {/* <div className="search-bar">
          <input type="text" placeholder="Busca tu espacio ideal..." />
          <button type="button">Buscar</button>
        </div> */}
      </header>

      {/* Carrusel de servicios */}
      <CarruselServices services={services} />
      <hr className="custom-hr" />

      <h2 className="welcome">Estos espacios únicos son el lugar perfecto para tu evento.</h2>

      {/* Iteramos sobre los servicios para generar los componentes TypeSectionCarrusel */}
      {services.map((service, index) => (
        <React.Fragment key={service.id}>
          {/* Renderizamos el TypeSectionCarrusel */}
          <TypeSectionCarrusel
            title={service.name}
            type={service.name.toLowerCase()}
            typeId={service.id}
            iconMap={service.icono}
          />

          {/* Insertamos publicidad de acuerdo a la frecuencia */}
          {/* Condición para cambiar la frecuencia */}
          {(index === 1 || index === 5) && <Contactanos />}
          {/* {(index === 1 || index === 5) && <Publish imageKey="publicidad1" />} */}
        </React.Fragment>
      ))}
    </div>
  );
};
